/* eslint-disable no-restricted-syntax */
export default function OnlyNumbers() {
  let checkOnKeypress = () => {}
  let checkOnPaste = () => {}
  const constraints = {
    min: 0,
    max: 100000,
  }

  return {
    mounted(el, { value, modifiers }) {
      function handler(e, result) {
        let REGEX = /^\d*$/g
        if (modifiers.decimal) {
          REGEX = /^\d*?(?:\.\d*)?$/g
        }

        if (!REGEX.test(result)) {
          return e.preventDefault()
        }

        if (!value) {
          return null
        }

        const resultNumber = +result
        if (
          (value.min >= 0 && resultNumber < constraints.min) ||
          (value.max >= 0 && resultNumber > constraints.max)
        ) {
          return e.preventDefault()
        }

        return null
      }

      checkOnKeypress = (event) => {
        const result = event.target.value + String.fromCharCode(event.charCode)
        return handler(event, result)
      }

      checkOnPaste = (event) => {
        const result = event.clipboardData.getData('text/plain')
        return handler(event, result)
      }

      el.addEventListener('keypress', checkOnKeypress)
      el.addEventListener('paste', checkOnPaste)
    },

    updated(el, { value }) {
      if (!value) {
        return
      }
      constraints.min = value.min
      constraints.max = value.max
    },

    unmounted(el) {
      el.removeEventListener('keypress', checkOnKeypress)
      el.removeEventListener('paste', checkOnPaste)
    },
  }
}
